export default [
  {
    id: 'abort',
    title: 'Abort',
    icon: 'fa fa-remove',
    shortKey: 'ESC',
  },
  {
    id: 'holdfeed',
    title: 'Hold feed',
    icon: 'fa fa-pause',
  },
  {
    id: 'material',
    title: 'Material',
    icon: 'fa fa-cube',
  },
  {
    id: 'batch',
    title: 'Batch',
    icon: 'fa fa-play',
    shortKey: 'F7',
  },
  {
    id: 'demo',
    title: 'Demo',
    icon: 'fa fa-play',
  },
  {
    id: 'override',
    title: 'Override',
    icon: 'fa fa-refresh',
    shortKey: 'F2',
  },
  {
    id: 'discharge',
    title: 'Discharge',
    icon: 'fa fa-arrow-down',
    shortKey: 'F10',
  },
  {
    id: 'rateplus',
    title: '+',
    icon: 'fa fa-plus',
  },
  {
    id: 'rateminus',
    title: '-',
    icon: 'fa fa-minus',
  },
  {
    id: 'stop',
    title: 'STOP',
    icon: 'fa fa-stop',
    shortKey: 'F4',
  },
  {
    id: 'washout',
    title: 'Washout',
    icon: 'fa fa-tint',
  },
];
